import { UserRole, isDistributorRole, isInternalRole } from '@lombok/shared';
import { useAuth } from '@/auth/AuthContext';
import { useAccountNames, useCustomer } from '@/data/hooks';

/**
 * The name of a customer or distributor account for the internal team, instead of its technical
 * id. A distributor also sees its sub-accounts' names. Customers only ever see their own account, so they
 * read their own account instead (never its id). While the names load, or for an account that cannot be read, an
 * internal user keeps the id.
 */
export function AccountName({ id }: { id: string }) {
  const { session } = useAuth();
  // Warehouse and drivers cannot list customers (the API answers 403): their screens bring the name along.
  const role = session?.user.role;
  const internal = role ? isInternalRole(role) && role !== UserRole.WAREHOUSE && role !== UserRole.DRIVER : false;
  const names = useAccountNames(internal || (role ? isDistributorRole(role) : false));
  // A customer cannot list accounts, but may read its own.
  const isCustomer = role === UserRole.CUSTOMER_USER;
  const own = useCustomer(isCustomer ? id : undefined);
  if (isCustomer) return <>{own.data?.name ?? (own.isLoading ? '…' : 'Tu cuenta')}</>;
  const name = names.data?.get(id)?.name;
  return <>{name ?? (names.isLoading ? '…' : id)}</>;
}
